import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    IExportPdf,
    IStatementOfAccountFilters,
} from "../types/statement-of-account.types";

export async function getStatementOfAccount(
    filters: IStatementOfAccountFilters
) {
    const response = await axios.get(`/report/account-statement`, {
        params: filters,
    });
    return response.data;
}

// Endpoint to send statement of account via email
export async function sendStatementOfAccount(
    filters: IStatementOfAccountFilters
) {
    const response = await axios.post(
        `report/account-statement`,
        {},
        {
            params: handleRemoveEmptyParamFromQueryParams(filters),
        }
    );
    return response.data;
}

// Endpoint to get exported pdf
export async function exportPdfs(params: IExportPdf) {
    const response = await axios.get("/pdf/export", {
        params: handleRemoveEmptyParamFromQueryParams(params),
        responseType: "blob",
    });
    return response.data;
}
